<edl-entries-form
    [attr.id]="id"
    [formGroup]="formGroup"
    [inlineAddButton]="inlineAddButton && canAddItemPackets"
    (inlineAddItem)="addItemPackets(pillTemplate)">
    <ng-template let-data>
        <item-packet-pill [pill]="data.entry.details.Pill" [isRemovable]="data.isRemovable"
            (onRemove)="data.onRemove()">
        </item-packet-pill>
    </ng-template>
</edl-entries-form>
<ng-template #pillTemplate let-data>
    <item-packet-pill [pill]="data.details.Pill" [showTitle]="true"></item-packet-pill>
</ng-template>
<div *ngIf="!inlineAddButton && canAddItemPackets" class="d-flex justify-content-end">
    <button type="button" class="btn btn-link" (click)="addItemPackets(pillTemplate)">+ Add Item Packets</button>
</div>
